export default "__VITE_ASSET__DlqaMxnQ__"